<template>
    <div class="scv-app-catalog-list-main">
        <div class="scv-loading">
            <div id="loader" class="scv-loader" :style="{ display: displayLoading }">
                <div class="scv-spinner-border-FRONTENDEX-MOBILE-APP scv-loader-spinner-border spinner-border"></div>
            </div>
        </div>
        <SearchInputMobileApp type="text"
                     class="input-text-scv-FRONTENDEX-MOBILE-APP scv-search-input"
                     :placeholder="placeholder"
                     @onEnterkeyDown="onEnterkeyDown" />
        <div class="d-flex" style="margin-top:8px; height: 44px;">
            <div class="mr-auto">
                <template v-if="!getingInstalledApp">
                    <a id="getInstalledAppText" class="scv-get-installed-app-text" style="line-height: 44px;" @click="onGetAppInstalled()">インストール状況を取得</a>
                </template>
                <template v-else>
                    <span class="scv-geting-installed-app-text">情報を取得中です..</span>
                </template>
            </div>
            <div class="d-flex align-items-center ms-auto">
                <div>
                    <button :disabled="isUpdateTab" v-show="!isUpdateTab" :class="isActiveBtn?'btn-scv-appcatalog-setting active':'btn-scv-appcatalog-setting'" id="navbarDropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="padding: 0px;" @touchstart="onTouchStart">
                        <div class="d-flex align-items-center justify-content-center flex-column">
                            <div class="icon-font-deepblue-s">
                                <img v-show="isFilterSelected" src="../assets/img/filter_on_bl.svg" style="width: 20px; height: 20px;">
                                <img v-show="!isFilterSelected" src="../assets/img/filter_bl.svg" style="width: 20px; height: 20px;">
                            </div>
                            <div class="scv-appcatalog-setting-text">
                                絞り込み
                            </div>
                        </div>
                    </button>
                    <div  v-show="!isUpdateTab" class="dropdown-menu scv-dropdown-menu scv-dropdown-menu-appcatalog" style="width: 250px; margin-right: 66px;" aria-labelledby="navbarDropdown">
                        <div class="scv-dropdown-menu-button">
                            <div class="dropdown-item switchButtonArea d-flex flex-row" style="padding: 0px 0px 0px 4px;">
                                <div style="margin-right: 8px;">未インストールアプリのみ表示</div>
                                <div class="switchArea">
                                    <input type="checkbox" id="switch" @click="onBtnSwitchClick" autocomplete="off">
                                    <label for="switch"></label>
                                    <label id="swImg" for="switch"></label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <button :disabled="isUpdateTab" v-show="!isUpdateTab" :class="isActiveBtn?'btn-scv-appcatalog-setting active':'btn-scv-appcatalog-setting'" id="navbarDropdownSort" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="padding: 0px 0px 0px 4px;" @touchstart="onTouchStart">
                        <div class="d-flex align-items-center justify-content-center flex-column">
                            <div class="icon-font-deepblue-s">
                                <img src="../assets/img/sort_bl.svg" style="width: 20px; height: 20px;">
                            </div>
                            <div class="scv-appcatalog-setting-text">
                                並び替え
                            </div>
                        </div>
                    </button>
                    <div class="dropdown-menu scv-dropdown-menu scv-dropdown-menu-appcatalog" aria-labelledby="navbarDropdownSort">
                        <div class="scv-dropdown-menu-button scv-dropdown-menu-button-appcatalog-sort">
                            <a class="dropdown-item" href="#" @click="onClickSortReleaseDate">
                                <img v-show="isReleaseDateSelected" src="../assets/img/check_bl.svg" height="24" width="24" style="margin-right: 8px;"> 
                                <div v-show="!isReleaseDateSelected" style="margin-left: 32px;" /> 
                                リリース日順
                            </a>
                        </div>
                        <div class="scv-dropdown-menu-button scv-dropdown-menu-button-appcatalog-sort">
                            <a class="dropdown-item" href="#" @click="onClickSortAppName">
                                <img v-show="isAppNameSelected" src="../assets/img/check_bl.svg" height="24" width="24" style="margin-right: 8px;"> 
                                <div v-show="!isAppNameSelected" style="margin-left: 32px;"></div>
                                アプリ名順
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="scv-app-catalog-list-area">
            <ul class="nav nav-pills" style="border-bottom: 0.5px solid #3C3C43; opacity: 0.4">
                <li class="nav-item" style="width: 50%;">
                    <div href="#update" class="nav-link-scv-FRONTENDEX-MOBILE-APP nav-link active" data-bs-toggle="tab" @click="onTabClick('update')">アップデート（{{updateCount}}）</div>
                </li>
                <li class="nav-item" style="width: 50%;">
                    <div href="#install" class="nav-link-scv-FRONTENDEX-MOBILE-APP nav-link" data-bs-toggle="tab" @click="onTabClick('install')">インストール（{{notInstalledCount}}）</div>
                </li>
            </ul>
            <div id="tabAppArea" class="tab-content scv-tab-app-area" @touchstart="touchStartHandler" @touchmove="touchMoveHandler" @touchend="touchEndHandler">
                <!-- アップデート -->
                <div id="update" class="tab-pane active">
                    <template v-if="updateApp.length === 0">
                        <div style="color: #73788C; font-size: 14px; letter-spacing: 0.15px; margin-top: 40px; text-align: center;">
                            データなし
                        </div>
                    </template>
                    <template v-else>
                        <AppCatalogList :appList="updateApp" :isInstall="false" @onDetailDisplay="onDetailDisplay" @onInstallUpdate="onInstallUpdate"></AppCatalogList>
                    </template>
                </div>

                <!-- インストール -->
                <div id="install" class="tab-pane">
                    <template v-if="currentFolderData.catalogFolderID != 0">
                        <div class="scv-open-folder">
                            <!-- 現在のフォルダ -->
                            <button class="scv-btn-design-FRONTENDEX-MOBILE-APP-square-FRONTENDEX-MOBILE-APP scv-btn-color-white-FRONTENDEX-MOBILE-APP"
                                    @click="onClickBackFolder"
                                    style="border-style: none; height: 40px; min-width: 72px; font-size: 16px; padding: 0;">
                                <div class="d-flex align-items-center">
                                    <img src="../assets/img/header_back_bl.svg" height="24" width="20">
                                    戻る
                                </div>
                            </button>
                            <div class="scv-open-folder-name ellipsis">
                                {{currentFolderData.catalogFolderName}}
                            </div>
                        </div>
                        <!-- セパレータ -->
                        <div class="scv-separator-line-list-FRONTENDEX-MOBILE-APP"></div>
                    </template>
                    <!-- 検索中はフォルダを表示しない -->
                    <template v-if="notInstalledCount === 0 && (installedCount === 0 || filterNotInstallApp === true)">
                        <div style="color: #73788C; font-size: 14px; letter-spacing: 0.15px; margin-top: 40px; text-align: center;">
                            データなし
                        </div>
                    </template>
                    <template v-else>
                        <template v-if="searchText === ''">
                            <FolderList :folderData="currentFolderData" :filterNotInstallApp="filterNotInstallApp" @onFolderClick="onFolderClick"></FolderList>
                            <template v-if="!filterNotInstallApp">
                                <template v-if="0 < installApp.length && 0 < currentFolderData.arSubFolderInfo.filter(x => 0 < x.appIDInFolder.length).length">
                                    <div class="scv-separator-line-list-FRONTENDEX-MOBILE-APP"></div>
                                </template>
                            </template>
                            <template v-else>
                                <template v-if="0 < installApp.length && 0 < currentFolderData.arSubFolderInfo.filter(x => 0 < x.appIDInFolder.filter(y => false == y.isInstalled).length).length">
                                    <div class="scv-separator-line-list-FRONTENDEX-MOBILE-APP"></div>
                                </template>
                            </template>
                        </template>
                        <AppCatalogList :appList="installApp" :isInstall="true" @onDetailDisplay="onDetailDisplay" @onInstallUpdate="onInstallUpdate"></AppCatalogList>
                    </template>
                </div>
            </div>
        </div>
        <!-- インストール確認ダイアログ -->
        <ConfirmDialog id="modalConfirmGetInstalledApp" confirmMessage="アプリのインストール状況を取得します。<br />取得に30秒～3分ほどかかるため、しばらくしてから画面を更新してください。" @onBtn1="onExecGetAppInstalled" btn1="取得開始"></ConfirmDialog>
        <!-- メッセージダイアログ -->
        <MessageDialog id="modalMessageCatalogListView" :messageText="messageHTML"></MessageDialog>
    </div>
</template>

<script lang="ts">
    import { Options, Vue } from 'vue-class-component';
    import { cloneDeep } from 'lodash';
    import SearchInputMobileApp from '@/components/Input/SearchInputMobileApp.vue';
    import AppCatalogList from '@/components/AppCatalog/AppCatalogList.vue';
    import FolderList from '@/components/AppCatalog/FolderList.vue';
    import { AppInfo, AppInfoUtil, FolderInfo, FolderSetting, FolderData } from '@/models/AppCatalog/AppInfo';
    import { AppInfo_ServerIF, Response_AppInfo_ServerIF, APP_TYPE } from '@/models/AppCatalog/AppInfo_ServerIF';
    import HttpRequestUtil from '@/util/HttpRequestUtil';
    import ConfirmDialog from '@/components/MessageBox/ConfirmDialog.vue';
    import MessageDialog from '@/components/MessageBox/MessageDialog.vue';    
    import { Response_VppInfo_ServerIF } from '@/models/AppCatalog/VppInfo_ServerIF';
    import { BootstrapUtil, NaturalCompare } from 'lib-vue-v2/util';

    @Options({
        components: {
            SearchInputMobileApp,
            AppCatalogList,
            FolderList,
            ConfirmDialog,
            MessageDialog
        },
        emits: [
            /**
             * @brief	詳細表示が押下
             * @param	AppInfo: 押下対象
             */
            "onDetailDisplay"

            /**
             * @brief	「アップデート」ボタン「インストール」ボタンが押下
             * @param	AppInfo: 押下対象
             */
            , "onInstallUpdate"
        ],
        watch: {
            currentFolderData: {
                handler: function () {
                    if(0 == this.currentFolderData.catalogFolderID){
                        this.placeholder = "すべてのアプリから検索";
                    }
                    else{
                        this.placeholder = "フォルダ内のアプリから検索";
                    }
                },
                deep: true,   // オブジェクトの監視
                immediate: false
            }
        },

    })

    export default class AppCatalogListView extends Vue {

        private readonly SORT_TYPE_APP_NAME = 0;        // アプリのソート：アプリ名順
        private readonly SORT_TYPE_RELEASE_DATE = 1;    // アプリのソート：リリース日順

        private updateAllApp = new Array<AppInfo>();    // アップデート対象の全アプリ
        private installAllApp = new Array<AppInfo>();   // インストール対象の全アプリ
        private updateApp = new Array<AppInfo>();       // アップデート対象のアプリ（表示）
        private installApp = new Array<AppInfo>();      // インストール対象のアプリ（表示）
        private updateCount = 0;                        // アップデート対象のアプリ数
        private notInstalledCount = 0;                  // インストール対象のアプリ数
        private installedCount = 0;                     // インストール済みのアプリ数
        private searchText = "";                        // 検索中の文字列
        private placeholder="すべてのアプリから検索";   // 検索欄
        private messageHTML = "";                       // 情報
        private displayLoading = 'none';                // くるくる(ローディング)の表示(block)/非表示(none)
        private touchStartY = 0;                        // タッチ開始Y座標
        private needRefresh = false;                    // リフレッシュが必要かどうか
        private IsRefreshing = false;                   // リフレッシュ中
        private getingInstalledApp = false;             // 最新のインストール状況取得中
        private filterNotInstallApp = false;            // 未インストールのみ表示絞り込みフラグ
        private isUpdateTab = true;                    // アップデートタブフラグ
        private isFilterSelected = false;               // フィルターフラグ
        private isReleaseDateSelected = false;          // リリース日ソートフラグ
        private isAppNameSelected = true;              // アプリ名順ソートフラグ
        private sortType = 0;                           // アプリのソート
        private checkMark = "";
        private folderInfoAll = new Array<FolderInfo>();        // 全フォルダ情報
        private folderSettingAll = new Array<FolderSetting>();  // 全フォルダ内のアプリ情報
        private folderDataAll = new FolderData();        // 全フォルダ情報
        private currentFolderData = new FolderData();    // 現在のフォルダ情報
        private isActiveBtn = false;                    // 絞り込み、並び替えがアクティブかどうか

        /**
         * @brief	mounted
         * @return	なし
         */
        public async mounted(): Promise<void> {
            
            // インストール可能アプリ一覧更新
            await this.refreshAppInfo();
        }

        /**
         * チェックボックスの変更イベントを処理します。
         */
        public onBtnSwitchClick(): void {
            const switchButtonEnable = document.getElementById("switch") as HTMLInputElement;

            if (switchButtonEnable.checked) {
                this.onClickFilterNotInstallApp();
                switchButtonEnable.checked = true;
                this.isFilterSelected = true;
            } else {
                this.onClickFilterAllApp();
                switchButtonEnable.checked = false;
                this.isFilterSelected = false;
            }
        }
        
        /**
         * 絞り込み：全てのアプリを表示のクリックイベント
         */
        private onClickFilterAllApp(): void {
            // 絞り込みなし
            this.filterNotInstallApp = false;

            // インストール対象のアプリをソートします。
            this.createListData();
        }

        /**
         * 絞り込み：未インストールアプリのみ表示のクリックイベント
         */
        private onClickFilterNotInstallApp(): void {
            // 未インストールアプリのみ表示
            this.filterNotInstallApp = true;

            this.createListData();
        }

        /**
         * アプリ名順でソートのクリックイベント
         */
        private onClickSortAppName(): void {
            // ソートの種類をアプリ名順に設定
            this.sortType = this.SORT_TYPE_APP_NAME;

            this.isReleaseDateSelected = false;
            this.isAppNameSelected = true;

            this.createListData();
        }

        /**
         * リリース日順でソートのクリックイベント
         */
        private onClickSortReleaseDate(): void {
            // ソートの種類をリリース日順に設定
            this.sortType = this.SORT_TYPE_RELEASE_DATE;

            this.isReleaseDateSelected = true;
            this.isAppNameSelected = false;

            // インストール対象のアプリをソートします。
            this.createListData();
        }

        /**
         * DBからインストール対象のアプリ一覧を取得します
         */
        private async getTargetAppInfo(): Promise<void> {
            // 取得済みのアプリ一覧情報をクリアする
            // 表示用はここではクリアしない。ここでクリアすると更新前に全部消えて、スクロール中の「一般公開アプリ」などのタイトルも途中で止まったので、
            // 失敗した時のみクリアする。成功した時は中でクリアしてから再設定されている
            this.updateAllApp.splice(0);
            this.installAllApp.splice(0);

            // インストール可能アプリ一覧を取得
            this.messageHTML = "";
            const res = await this.getTargetAppInfoImpl();

            // レスポンスが取れないときはネットワークエラー
            if (undefined == res) {
                // 失敗
                this.messageHTML = "インターネットに接続されていません。<br />モバイルデータ通信またはWi-Fiが有効になっているか確認してください。";
            }
            else if (res != 200) {
                // 失敗
                this.messageHTML = "アプリカタログの表示に失敗しました。<br />（エラーコード：" + res + "）";
            }

            if (0 != this.messageHTML.length) {
                // 表示用のアプリ一覧情報をクリアする
                this.updateApp.splice(0);
                this.installApp.splice(0);

                // エラーあり
                BootstrapUtil.showModal('modalMessageCatalogListView');
            }
        }

        /**
         * DBからインストール対象のアプリ一覧を取得します
         * return httpステータスコード（undefined : ネットワークエラー）
         */
        private async getTargetAppInfoImpl(): Promise<number | undefined> {

            // フォルダ情報の初期化
            this.folderInfoAll = [];
            this.folderSettingAll = [];

            const res = await HttpRequestUtil.get(
                "/App/GetAppList_AppStore"
            );

            // レスポンスが取れないときはネットワークエラー
            if (undefined == res || undefined == res.status) {
                // 失敗
                return undefined;
            }

            let response = new Response_AppInfo_ServerIF();
            if (res.status == 200) {
                // レスポンス
                if (res.data !== undefined) {
                    response = cloneDeep(res.data);

                    const ret = await this.getPublicAppInfo(response.appList);
                    if (undefined == ret || 200 != ret) {
                        return ret;
                    }

                    // フォルダ情報設定
                    response.folderInfoList.forEach(item => {
                        let folderInfo = new FolderInfo();
                        folderInfo.catalogFolderID = item.catalogFolderID;
                        folderInfo.parentCatalogFolderID = item.parentCatalogFolderID;
                        folderInfo.catalogFolderName = item.catalogFolderName;
                        folderInfo.catalogFolderDisplayOrder = item.catalogFolderDisplayOrder;
                        folderInfo.catalogFolderDesign = item.catalogFolderDesign;
                        this.folderInfoAll.push(folderInfo);
                    });
                    response.folderSettingList.forEach(item => {
                        let folderSetting = new FolderSetting();
                        folderSetting.catalogFolderID = item.catalogFolderID;
                        folderSetting.settingID = item.settingID;
                        this.folderSettingAll.push(folderSetting);
                    });

                    // アップデートリストのソート
                    this.updateAllApp.sort(function (a, b) {
                        // 第一ソート：アップデート可能かどうか
                        if (a.hasUpdateAvailable && !b.hasUpdateAvailable) {
                            // アップデート可能なら上
                            return -1;
                        }
                        else if (!a.hasUpdateAvailable && b.hasUpdateAvailable) {
                            // アップデート不可能なら下
                            return 1;
                        }

                        // 第二ソート：名前
                        if (a.trackName < b.trackName) {
                            return -1;
                        }
                        if (a.trackName > b.trackName) {
                            return 1;
                        }

                        return 0;
                    });

                    // フォルダ情報作成
                    this.folderDataAll.Load(this.folderInfoAll, this.folderSettingAll, this.installAllApp);
                    this.currentFolderData = this.folderDataAll;

                    // 表示用データの作成
                    this.createListData();
                }
                else {
                    console.log("DB情報取得失敗 想定していないレスポンス型 " + res.status);
                    return 500;
                }
            }
            else {
                console.log("DB情報取得失敗 想定していないレスポンス型 " + res.status);
                return res.status;
            }
            return res.status;
        }

        /**
         * インストール対象のアプリをソートします。
         */
        private sortInstallAppList(): void {
            // インストールリストのソート
            this.installApp.sort((a, b) => {
                switch (this.sortType) {
                    // アプリ名順
                    case this.SORT_TYPE_APP_NAME:
                        if (a.trackName < b.trackName) {
                            return -1;
                        }
                        if (a.trackName > b.trackName) {
                            return 1;
                        }
                        break;
                    // リリース日順
                    case this.SORT_TYPE_RELEASE_DATE:
                        return NaturalCompare.compare(a.currentVersionReleaseDate, b.currentVersionReleaseDate, false);
                }

                return 0;
            });
        }

        /**
         * 公開アプリの詳細情報をWEBAPIから取得
         * return httpステータスコード（undefined : ネットワークエラー）
         */
        private async getPublicAppInfo(targetList: Array<AppInfo_ServerIF>): Promise<number | undefined> {
            const BASE_URL_STORE = "https://itunes.apple.com/lookup?country=JP&lang=ja_jp&id=";
            const BASE_URL_VPP = "https://uclient-api.itunes.apple.com/WebObjects/MZStorePlatform.woa/wa/lookup?version=2&p=mdm-lockup&caller=MDM&cc=jp&id=";
            const CHECK_URL_LEN = 2000;
            var urlStore = BASE_URL_STORE;
            var urlVpp = BASE_URL_VPP;
            var dicAppServerIF = new Map<number, AppInfo_ServerIF>();
            var dicAppServerVppIF = new Map<number, AppInfo_ServerIF>();
            for (var target of targetList) {
                // VPPアプリとStoreアプリでは、GetのURLが異なるので別々に取得
                if (APP_TYPE.APP_TYPE_VPP == target.appType) {
                    // VPPアプリ
                    if (0 != dicAppServerVppIF.size) {
                        urlVpp += ",";
                    }
                    urlVpp += String(target.iTunesStoreID);
                    dicAppServerVppIF.set(target.iTunesStoreID, target);

                    // URLサイズをチェックして超えていたらリクエストをかける
                    if (CHECK_URL_LEN < urlVpp.length) {
                        const res = await this.lookupAppVpp(urlVpp, dicAppServerVppIF);
                        if (undefined == res || 200 != res) {
                            console.log("VppのLookup に失敗1 : " + urlVpp);
                            return res;
                        }

                        urlVpp = BASE_URL_VPP;
                        dicAppServerVppIF.clear();
                    }
                }
                else {
                    // Storeアプリ
                    if (0 != dicAppServerIF.size) {
                        urlStore += ",";
                    }
                    urlStore += String(target.iTunesStoreID);
                    dicAppServerIF.set(target.iTunesStoreID, target);

                    // URLサイズをチェックして超えていたらリクエストをかける
                    if (CHECK_URL_LEN < urlStore.length) {
                        const res = await this.lookupApp(urlStore, dicAppServerIF);
                        if (undefined == res || 200 != res) {
                            console.log("AppのLookup に失敗1 : " + urlStore);
                            return res;
                        }

                        urlStore = BASE_URL_STORE;
                        dicAppServerIF.clear();
                    }
                }
            }

            // 残りのリクエスト
            if (0 < dicAppServerIF.size) {
                const res = await this.lookupApp(urlStore, dicAppServerIF);
                if (undefined == res || 200 != res) {
                    console.log("AppのLookup に失敗1 : " + urlStore);
                    return res;
                }
            }

            // 残りのリクエスト
            if (0 < dicAppServerVppIF.size) {
                const res = await this.lookupAppVpp(urlVpp, dicAppServerVppIF);
                if (undefined == res || 200 != res) {
                    console.log("VppのLookup に失敗1 : " + urlVpp);
                    return res;
                }
            }

            return 200;
        }

        /**
         * 公開アプリの詳細情報をWEBAPIから取得(リクエスト実装部)
         * return httpステータスコード（undefined : ネットワークエラー）
         */
        private async lookupApp(url: string, dicServerInfo: Map<number, AppInfo_ServerIF>): Promise<number | undefined> {

            // キャッシュされないためのクエリを追加
            url += '&rnd=' + (new Date).getTime().toString();

            // iTunes検索
            const res = await HttpRequestUtil.get(url);

            // レスポンスが取れないときはネットワークエラー
            if (undefined == res || undefined == res.status) {
                return undefined;
            }

            if (res.status == 200) {
                // JSON形式にする。
                let jsonData = JSON.parse(JSON.stringify(res.data));
                
                for (let cnt = 0; cnt < jsonData.resultCount; ++cnt) {
                    let app = AppInfoUtil.AppInfoToPublicAppJson(jsonData.results[cnt]);

                    const svrInfo = dicServerInfo.get(app.id);
                    if (undefined != svrInfo) {
                        app.isVpp = (APP_TYPE.APP_TYPE_VPP == svrInfo.appType);
                        app.hasUpdateAvailable = svrInfo.hasUpdateAvailable;
                        app.settingID = svrInfo.settingID;
                        app.isInstalled = svrInfo.isInstalled;
                        app.explanation = svrInfo.explanation;
                    }

                    // インストールには全アプリケーションを表示する
                    this.installAllApp.push(app);

                    // インストール済みのものはアップデートにも追加
                    if (app.isInstalled) {
                        this.updateAllApp.push(app);
                    }
                }
            }
            else {
                return res.status;
            }

            return res.status;
        }

        /**
         * VPPアプリの詳細情報をWEBAPIから取得(リクエスト実装部)
         * return httpステータスコード（undefined : ネットワークエラー）
         */
        private async lookupAppVpp(url: string, dicServerInfo: Map<number, AppInfo_ServerIF>): Promise<number | undefined> {

            // キャッシュされないためのクエリを追加
            //url += '&rnd=' + (new Date).getTime().toString();

            // iTunes検索
            //const res = await HttpRequestUtil.get(url);

            // レスポンスが取れないときはネットワークエラー
            //if (undefined == res || undefined == res.status) {
            //    return undefined;
            //}

            let emptyVpp: number[] = [];
            var emptyVppServerInfo = new Map<number, AppInfo_ServerIF>();
            dicServerInfo.forEach((svrInfo, key) => {
                emptyVpp.push(key);
                emptyVppServerInfo.set(key, svrInfo);
            });

            //if (res.status == 200) {
            //    // JSON形式にする。
            //    let jsonData = JSON.parse(JSON.stringify(res.data));

            //    dicServerInfo.forEach((svrInfo, key) => {
            //        let app = AppInfoUtil.AppInfoToVppAppJson(jsonData.results[key]);

            //        if (undefined != svrInfo) {
            //            app.isVpp = (APP_TYPE.APP_TYPE_VPP == svrInfo.appType);
            //            app.hasUpdateAvailable = svrInfo.hasUpdateAvailable;
            //            app.settingID = svrInfo.settingID;
            //            app.isInstalled = svrInfo.isInstalled;
            //            app.explanation = svrInfo.explanation;
            //        }

            //        if ("" != app.trackName) {
            //            // インストールには全アプリケーションを表示する
            //            this.installAllApp.push(app);

            //            // インストール済みのものはアップデートにも追加
            //            if (app.isInstalled) {
            //                this.updateAllApp.push(app);
            //            }
            //        } else {
            //            emptyVpp.push(key);
            //            emptyVppServerInfo.set(key, svrInfo);
            //        }
            //    });
            //}
            //else {
            //    // uclient-api.itunes.apple.comからの取得に失敗した場合は、収集サーバー問い合わせ用のコンテナに退避
            //    dicServerInfo.forEach((svrInfo, key) => {
            //        emptyVpp.push(key);
            //        emptyVppServerInfo.set(key, svrInfo);
            //    });
            //}

            // 取得できなかったVPPアプリは収集サーバーへ問い合わせる
            if (0 < emptyVpp.length) {
                var vppAppInfo = new Array<AppInfo>();  // VPPアプリ情報
                const resVpp = await this.GetVPPInfo(emptyVpp, vppAppInfo);
                if (200 == resVpp) {
                    // インストールに追加
                    vppAppInfo.forEach((app) => {
                        // 存在チェック
                        if (emptyVppServerInfo.has(app.id)) {
                            let svrInfo = emptyVppServerInfo.get(app.id);

                            if (undefined != svrInfo) {
                                app.isVpp = (APP_TYPE.APP_TYPE_VPP == svrInfo.appType);
                                app.hasUpdateAvailable = svrInfo.hasUpdateAvailable;
                                app.settingID = svrInfo.settingID;
                                app.isInstalled = svrInfo.isInstalled;
                                app.explanation = svrInfo.explanation;
                            }

                            // インストールには全アプリケーションを表示する
                            this.installAllApp.push(app);

                            // インストール済みのものはアップデートにも追加
                            if (app.isInstalled) {
                                this.updateAllApp.push(app);
                            }
                        }
                    });
                }
                return resVpp;
            }

            return 200;
        }

        /**
         * 「詳細表示」ボタンが押下
         */
        private onDetailDisplay(app: AppInfo): void {
            this.$emit("onDetailDisplay", app);
        }

        /**
         * 「アップデート」ボタン「インストール」ボタンが押下
         */
        private onInstallUpdate(app: AppInfo): void {
            this.$emit("onInstallUpdate", app);
        }

        /**
         * 親フォルダへ戻るボタンクリック
         */
        private onClickBackFolder(): void {
            const divParentFolder = this.folderDataAll.GetParentItemData(this.currentFolderData.catalogFolderID);
            //  自身がルートの場合
            if (undefined == divParentFolder) {
                return;
            }
            this.currentFolderData = divParentFolder;

            // 表示用データの作成
            this.createListData();
        }

        /**
         * フォルダクリック
         */
        private onFolderClick(catalogFolderID: number): void {
            // クリックされたフォルダをサブフォルダから探す
            let data = this.currentFolderData.arSubFolderInfo.find(x => x.catalogFolderID == catalogFolderID);
            if (undefined != data) {
                this.currentFolderData = data;
            }

            // 表示用データの作成
            this.createListData();
        }

        /**
         * 「最新のインストール状況を取得」ボタンが押下
         */
        private async onGetAppInstalled(): Promise<void> {
            // 確認メッセージ
            BootstrapUtil.showModal('modalConfirmGetInstalledApp');
        }

        /**
         * 「最新のインストール状況を取得」処理
         */
        private async onExecGetAppInstalled(): Promise<void> {
            // 「情報を取得中です..」に変更
            this.getingInstalledApp = true;

            const res = await HttpRequestUtil.get(
                "/App/RequestInstaledAppUpload"
            );

            this.messageHTML = "";

            // レスポンスが取れないときはネットワークエラー
            if (undefined == res || undefined == res.status) {
                // 失敗
                this.messageHTML = "インターネットに接続されていません。<br />モバイルデータ通信またはWi-Fiが有効になっているか確認してください。";
            }
            else if (res.status != 200) {
                // 失敗
                this.messageHTML = "取得開始に失敗しました。<br />（エラーコード：" + res.status + "）";
            }

            // 「最新のインストール状況を取得」に戻す
            this.getingInstalledApp = false;

            if (0 != this.messageHTML.length) {
                // エラーあり
                BootstrapUtil.showModal('modalMessageCatalogListView');
                return;
            }
        }

        /**
         * @brief	検索ボックスでの Enterキー
         * @return	なし
         */
        private onEnterkeyDown(searchText: string): void {
            this.searchText = searchText;
            this.createListData();
        }

        /**
         * @brief	リストデータの作成
         * @return	なし
         */
        private createListData(): void {
            // フォルダ順ソート
            this.currentFolderData.arSubFolderInfo.sort(function (a, b) {
                if (0 == a.catalogFolderDisplayOrder) {
                    // フォルダ名で自然順ソートする(M1用)
                    return NaturalCompare.compare(a.catalogFolderName, b.catalogFolderName, false);
                }
                else {
                    // DisplayOrderの順番でソートする(オンプレ用)
                    if (a.catalogFolderDisplayOrder < b.catalogFolderDisplayOrder) {
                        return -1;
                    }
                    if (a.catalogFolderDisplayOrder > b.catalogFolderDisplayOrder) {
                        return 1;
                    }
                }

                return 0;
            });

            this.updateApp = new Array<AppInfo>();
            this.installApp = new Array<AppInfo>();
            this.updateCount = 0;
            this.notInstalledCount = 0;
            this.installedCount = 0;

            const searchUpper = this.searchText.toUpperCase();
            // アップデート対象
            for (let i = 0; i < this.updateAllApp.length; i++) {
                if (0 == searchUpper.length || this.updateAllApp[i].trackName.toUpperCase().includes(searchUpper)) {
                    this.updateApp.push(this.updateAllApp[i]);

                    if (this.updateAllApp[i].hasUpdateAvailable || "0B" == this.updateAllApp[i].fileSizeBytes) {
                        // 実際にアップデートできるアプリ数を表示
                        this.updateCount++;
                    }
                }
            }

            // 未インストールのみ表示フラグがOFF
            if(!this.filterNotInstallApp){
                if (0 == searchUpper.length) {
                    this.installApp = this.currentFolderData.installApp;
                    this.notInstalledCount = this.currentFolderData.appIDInFolder.filter(x=> false == x.isInstalled).length;
                    this.installedCount = this.currentFolderData.appIDInFolder.filter(x=> true == x.isInstalled).length;
                }
                else{
                    this.installApp = this.currentFolderData.appIDInFolder.filter(x=> x.trackName.toUpperCase().includes(searchUpper));
                    this.notInstalledCount = this.installApp.filter(x => false == x.isInstalled).filter(x => x.trackName.toUpperCase().includes(searchUpper)).length;
                    this.installedCount = this.installApp.filter(x => true == x.isInstalled).filter(x => x.trackName.toUpperCase().includes(searchUpper)).length;
                }
            }
            else{
                if (0 == searchUpper.length) {
                    this.installApp = this.currentFolderData.installApp.filter(x=> false == x.isInstalled);
                    this.notInstalledCount = this.currentFolderData.appIDInFolder.filter(x => false == x.isInstalled).length;
                    this.installedCount = this.currentFolderData.appIDInFolder.filter(x => true == x.isInstalled).length;
                }
                else{
                    this.installApp = this.currentFolderData.appIDInFolder.filter(x=> false == x.isInstalled).filter(x=> x.trackName.toUpperCase().includes(searchUpper));
                    this.notInstalledCount = this.installApp.filter(x=> false == x.isInstalled).filter(x=> x.trackName.toUpperCase().includes(searchUpper)).length;
                    this.installedCount = this.installApp.filter(x=> true == x.isInstalled).filter(x=> x.trackName.toUpperCase().includes(searchUpper)).length;
                }
            }

            this.sortInstallAppList();
        }

        /**
         * @brief	DBからVPPアプリ情報を取得(AdmID指定)
         * @return	 httpステータスコード（undefined : ネットワークエラー）
         */
        private async GetVPPInfo(vppList: number[], vppAppInfo: Array<AppInfo>): Promise<number | undefined> {
            var bodyData = {
                vppList: vppList,
            };

            const res = await HttpRequestUtil.post(
                "/App/GetVPPInfoByAdmID",
                bodyData
            );

            // レスポンスが取れないときはネットワークエラー
            if (undefined == res || undefined == res.status) {
                // 失敗
                return undefined;
            }

            let response = new Response_VppInfo_ServerIF();
            if (res.status == 200) {
                // レスポンス
                if (res.data != undefined) {
                    response = Object.assign(response, res.data);

                    response.vppList.forEach((appInfo) => {
                        let convertAppInfo = AppInfoUtil.AppInfoToCustomAppInfo(appInfo);
                        if (undefined != convertAppInfo) {
                            vppAppInfo.push(AppInfoUtil.AppInfoToCustomAppInfo(convertAppInfo));
                        }
                    });
                }
            }

            return res.status;
        }

        // タブ押下時
        private onTabClick(strClickedTab: string): void {
            if ('update' == strClickedTab) {
                this.isUpdateTab = true;
                this.placeholder = "すべてのアプリから検索";
                return;
            }
            
            
            if(0 == this.currentFolderData.catalogFolderID || 0 == this.currentFolderData.arSubFolderInfo.length){
                this.placeholder = "すべてのアプリから検索";
            }
            else{
                this.placeholder = "フォルダ内のアプリから検索";
            }
            this.isUpdateTab = false;
        }

        // タッチ開始イベントハンドラ
        private touchStartHandler(e: any): void {
            // タッチ開始のY座標を覚えておく
            this.touchStartY = e.touches[0].pageY;

            // 更新フラグ初期化
            this.needRefresh = false;
        }

        // タッチ中の移動イベントハンドラ
        private touchMoveHandler(e: any): void {
            // まだ更新フラグを立てていない
            if (!this.needRefresh) {
                // 現在のタッチY座標を取得
                const y = e.touches[0].pageY;

                // タッチエリアの情報取得
                const tabAppArea = document.getElementById('tabAppArea');

                if (null != tabAppArea) {
                    // 上にスクロールしている
                    if (y > (this.touchStartY + 100)) {
                        // スクロール位置が一番上(アプリリスト部分がスクロールしている場合)
                        if (tabAppArea.scrollTop < 0) {
                            const loader = document.getElementById('loader');
                            if (null != loader) {
                                // くるくるアイコンについて表示領域を確保して表示する(アプリリスト部分がスクロールしている場合、検索ボックスの上部の表示するスペースがないため)
                                loader.style.position = 'static';
                                loader.style.marginTop = '-8px';
                            }
                            
                            this.needRefresh = true;
                            this.displayLoading = 'block';
                        }
                        // スクロール位置が一番上(ウィンドウ全体がスクロールしている場合)
                        else if (null != document.scrollingElement && document.scrollingElement.scrollTop < 0) {
                            const loader = document.getElementById('loader');
                            if (null != loader) {
                                // くるくるアイコンについて表示領域を確保せず表示する(ウィンドウ全体がスクロールしている場合、検索ボックスの上部に既に表示できる分だけの余白があるため)
                                loader.style.position = 'absolute';
                                loader.style.marginTop = '-24px';
                            }

                            this.needRefresh = true;
                            this.displayLoading = 'block';
                        }
                    }
                }
            }
        }

        // タッチ終了イベントハンドラ
        private async touchEndHandler(e: any): Promise<void> {
            // 更新フラグが立っていれば
            if (this.needRefresh) {
                // 更新フラグ初期化
                this.needRefresh = false;
                
                // インストール可能アプリ一覧更新
                await this.refreshAppInfo();
            }
        }

        // インストール可能アプリ一覧更新
        private async refreshAppInfo(): Promise<void> {
            // 現在更新中でなければ更新を行う
            if (!this.IsRefreshing) {
                // 更新中フラグを立てる
                this.IsRefreshing = true;

                const loader = document.getElementById('loader');
                if (null != loader) {
                    // くるくるアイコンについて表示領域を確保せず表示しているなら
                    if (loader.style.position == 'absolute') {
                        // タッチ終了のタイミングで表示領域を確保する(表示領域を確保しなかった場合、タッチ終了でウィンドウ全体が戻っていった時に
                        // くるくるアイコンがウィンドウ外に半分程見切れてしまう為、タッチ終了のタイミングで表示領域を確保する)
                        loader.style.position = 'static';
                        loader.style.marginTop = '-8px';
                    }
                }

                // インストール可能アプリ一覧を取得
                await this.getTargetAppInfo();

                // 更新アニメーション非表示
                this.displayLoading = 'none';

                // 更新中フラグ初期化
                this.IsRefreshing = false;
            }
        }

        // タッチ開始イベント(「絞り込み」「並び替え」ボタン)
        private onTouchStart(): void {
            this.isActiveBtn = true;
        }
    }
</script>

<style scoped>
    /* メイン画面 */
    .scv-app-catalog-list-main {
        display: flex;
        flex-grow: 1;
        flex-direction: column;
        margin: 16px 16px 0px 16px;
    }

    /* アプリカタログ一覧（タブ以下） */
    .scv-app-catalog-list-area {
        margin-top: 8px;
        display: flex;
        width: 100%;
        flex-direction: column;
        flex-grow: 1;
    }

    /* アプリカタログ一覧（タブ未満） */
    .scv-tab-app-area {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        overflow: auto;
        height: 0px; /* "flex-grow-1"を有効にするためにheightを設定する必要がある。*/
    }

    /* 検索ボックス */
    .scv-search-input {
        height: 36px;
        width: 100%;
    }

    .scv-dropdown-menu-appcatalog {
        background-color: #FEFEFE;
        box-shadow: 0px 0px 12px 0px rgba(0,0,0,0.12);
    }

    /* 「絞り込み」、「並び替え」ボタン */
    .btn-scv-appcatalog-setting {
        background-color: #fff;
        border: none;
        width: 56px;
        height: 44px;
        outline: none;
    }
        .btn-scv-appcatalog-setting:active {
            opacity: 0.4;
        }

    /* 「絞り込み」、「並び替え」ボタン下の文字 */
    .scv-appcatalog-setting-text {
        font-size: 10px;
        color: #37A0F5;
        line-height: 1.25;
    }

    .scv-dropdown-menu-button-appcatalog-sort {
        min-width: 160px;
        padding: 0px 16px 0px 4px;
        color: #4F5356;
        line-height: 1.25;
    }

    /* 絞り込みのツールチップ */
    .scv-filter-info {
        background-color: #9696A0;
        display: none;
    }

    /* ソートのツールチップ */
    .scv-sort-info {
        background-color: #9696A0;
        display: none;
    }

    /* 開いているフォルダ名 */
    .scv-open-folder {
        height: 52px;
        width: 100%;
        padding: 0px 8px 0px 8px;
        display: flex;
        align-items: center;
    }

    .scv-open-folder-name {
        font-weight: 700;
        font-size: 15px;
        color: #4F5356;
        line-height: 1.25;
        text-align: center;
        width: 100%;
        padding-right: 72px; /* 「戻る」ボタンの分だけ右を空ける */
    }

    /* タブ */
    .nav-link-scv-FRONTENDEX-MOBILE-APP.nav-link {
        height: 50px;   /* border抜きで48px */
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 13px;
        color: #242424;
        border-radius: 0px;
    }

        /* タブ（選択中） */
        .nav-link-scv-FRONTENDEX-MOBILE-APP.nav-link.active {
            color: #05A0F0;
            background-color: #fff;
            border-bottom: 2px solid #05A0F0;
        }

    /* 最新のインストール状況の取得 */
    .scv-get-installed-app-text {
        font-size: 13px;
        color: #2594EB;
        height: 24px;
        border-top: 16px;
        padding-left: 4px;
        padding-right: 4px;
        text-decoration: none;
    }

    /* 情報を取得中です.. */
    .scv-geting-installed-app-text {
        font-size: 13px;
        color: #242424;
        height: 24px;
        margin-top: 8px;
        padding-left: 4px;
        padding-right: 4px;
    }

    /* ローディング */
    .scv-loading {
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
    }

    .scv-loader {
        width: 40px;
        height: 40px;
    }

    .scv-loader-spinner-border {
        width: 1.75em;
        height: 1.75em;
    }
    .switchButtonArea {
        width: 0px;
        height: 0px;
        background: #fff;
        border-radius: 30px;
    }

    .switchArea input[type="checkbox"]:checked ~ .text {
        color: #1464B9;
    }

    /* === ボタンを表示するエリア ============================== */
    .switchArea {
        width: 84px;
        height: 32px;
        position: relative;
        padding-top: 3px;
        padding-left: 3px;
        margin-right: 16px;
        background: transparent;
    }

        /* === チェックボックス ==================================== */
        .switchArea input[type="checkbox"] {
            display: none; /* チェックボックス非表示 */
        }

        /* === チェックボックスのラベル（標準） ==================== */
        .switchArea label {
            box-sizing: border-box;
            width: 32px;
            height: 20px;
            margin-top: 4.5px;
            border: 2px solid #999999;
            border-radius: 30px;
            background: #999999;
        }

        /* === チェックボックスのラベル（ONのとき） ================ */
        .switchArea input[type="checkbox"]:checked + label {
            background: #1464B9;
            border-color: #1464B9;
        }

        /* === 丸部分のSTYLE（標準） =============================== */
        .switchArea #swImg {
            position: absolute;
            width: 17px;
            height: 17px;
            background: #fff;
            top: 4.5px;
            left: 4px;
            border: 0px;
            border-radius: 26px;
            transition: .2s;
        }

        /* === 丸部分のSTYLE（ONのとき） =========================== */
        .switchArea input[type="checkbox"]:checked ~ #swImg {
            transform: translateX(12px);
        }

    .ellipsis {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

</style>